"use client";
import React from "react";
import dynamic from "next/dynamic";

const SummarizerEditor = dynamic(
  () => import("@/components/tools/SummarizerEditor/SummarizerEditor"),
  { ssr: false },
);
const SummarizerCoreSection = () => {
  return (
    <div className="my-4 rounded-[8px] bg-[#FFFFFF]">
      <SummarizerEditor />
    </div>
  );
};
export default SummarizerCoreSection;
